var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"postSocialShare"},[_c('div',{staticClass:"postSocialShareIcons"},[_c('ul',{staticClass:"list-inline"},[_c('li',[_c('ShareNative',{attrs:{"button-class":'tr-button--secondary tr-button--icon',"label":false}})],1)])])])}
var staticRenderFns = []

export { render, staticRenderFns }